 /* eslint-disable no-unused-vars */
import React, { Component } from "react";
import { connect } from "react-redux";

import { TrackEventName } from '../../constants/SegmentEvents';
import {segmentEventTracker} from '../../../../utils/SegmentEventTracker';
import { isRestrictedAccess } from '../../../../utils/cookies';


export class ZendeskComponent extends Component {

  initializeZendesk = () => {
    this.addScript()

    window.zESettings = {
      webWidget: {
        position:{
          horizontal: 'right',
          vertical: 'bottom'
        },
        offset: {
          vertical: '0px',
          mobile: {
            horizontal: '0px',
            vertical: '60px',
          }
        },
      }
    };

    if(window.zE){
      window.zE('webWidget', 'show')
      //clear end chat event
      window.zE('webWidget:on', 'chat:end', () => {})
    }

  }

  mapEvents = () =>{
   this.prefillChat()

    const events = {
      open: TrackEventName.ZENDESK_OPEN_CLICKED,
      'chat:start': TrackEventName.ZENDESK_START_CHAT_CLICKED,
      'chat:end': TrackEventName.ZENDESK_END_CHAT_CLICKED,
      close: TrackEventName.ZENDESK_CLOSE_CLICKED
    }

    this.segmentEvents(events)
  }

  segmentEvents = (events) => {
    for (let key of Object.keys(events)) {
      window.zE('webWidget:on', key, () => {
        this.addTracker(events[key])
      })
    }
  }

  addTracker = (event) =>{
    segmentEventTracker.trackEvent(event)
  }

  prefillChat(){
    const { user, company } = this.props
    if(user.first_name && user.last_name && user.email) {
      window.zE('webWidget', 'prefill', {
        name: {
          value: `${user.first_name} ${user.last_name}`,
        },
        email: {
          value: user.email,
        },
      });
    }

    if(company){
      window.zE('webWidget', 'updateSettings', {
        webWidget: {
          chat: {
            tags: [`leadID_${company.id}`]
          },
        }
      });
    }
  }

  get zendeskUrl(){
    return "https://static.zdassets.com/ekr/snippet.js?key=ef1aa032-c0fe-4a31-b875-09a79f12dd6f"
  }

  addScript(){
    const script = document.createElement("script");
    script.src = this.zendeskUrl;
    script.onload = this.mapEvents;
    script.async = true;
    script.id= "ze-snippet";
    const tag = document.querySelectorAll(`script[src="${this.zendeskUrl}"]`)
    if(tag.length === 0) document.body.appendChild(script) ;
  }

  componentDidMount () {
    // NOTE: we only want to show zendesk
    // to customers only and not to internal users.
    if (!isRestrictedAccess()) {
      this.initializeZendesk();
    }
  }

  componentWillUnmount() {
    try {
      const tag = document.querySelectorAll(`script[src="${this.zendeskUrl}"]`)
      if (tag.length === 0) tag.remove();
    } catch (error) {
      console.log(error)
    }
  }

  render(){
    return null
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    company: state.company,
  }
}
export default (connect(mapStateToProps)(ZendeskComponent));



// WEBPACK FOOTER //
// ./src/features/shared/components/misc/ZendeskComponent.js